import { useSuspenseQuery } from '@tanstack/react-query';
import { API } from 'api';
import { apiName, apiBasePath } from 'assets/constants';
import { ActionPlanOutcomesCategory } from 'types/ActionPlan';

export async function getActionPlanCategories(kitId: string) {
  const response = await API.get(
    apiName,
    `${apiBasePath}/actionplan/v5/${kitId}/categories`,
    {},
  );

  return response?.result;
}

export const getActionPlanCategoriesQuery = (kitId?: string | null) => ({
  queryKey: [apiName, 'actionPlanCategories', kitId],
  queryFn: () => (kitId ? getActionPlanCategories(kitId) : []),
});

const useActionPlanCategories = ({ kitId }: { kitId?: string | null }) => {
  const actionPlanDataQuery = useSuspenseQuery<
    ActionPlanOutcomesCategory[] | null
  >(getActionPlanCategoriesQuery(kitId));
  return actionPlanDataQuery;
};

export default useActionPlanCategories;
